import React, { ReactElement } from "react";
import { Layout, TokenTextAppearance, Text } from "@volkswagen-onehub/components-core";
import styled from "styled-components";

const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.static350};
`;

export function NoVwVehicleModalContentVwView(): ReactElement {
  return (
    <Layout>
      <StyledText appearance={TokenTextAppearance.headline400} bold>
        Vehicle not found system
      </StyledText>
      <Text>
        <Text appearance={TokenTextAppearance.copy200} bold>
          We couldn't locate your vehicle in the Volkswagen system.
        </Text>
        <br />
        <br />
        It looks like the entered details belong to another brand.
        <br />
        Please try signing in using the Audi app.
      </Text>
    </Layout>
  );
}
